/* tslint:disable */
import * as qiniu from 'qiniu-js';
import { CommonController, ApplicationListController } from './request.service';

export interface QiniuResponse {
  resourceId: number;
  hash: string;
  key: string;
  fileUrl: string;
}
interface QiniuProgress {
  progress: number;
  totalBytesSent: number;
  totalBytesExpectedToSend: number;
}

/**
 *
 * @param file 网页选择图片的文件
 */
export function fileUploader(file: any, fileName: string) {
  return new Promise<QiniuResponse>((resolve, reject) => {
    let token = '';
    CommonController.getQiniuEtcToken().then(res => {
      token = res.data.token;
      const key = new Date().getTime() + fileName;
      /*
       * config.useCdnDomain: 是否使用 cdn 加速域名，true or false，默认为 false。
       * config.disableStatisticsReport: 是否禁用日志报告，为布尔值，默认为false。
       * config.region: 选择上传域名区域；当为 null 或 undefined 时，自动分析上传域名区域
       * config.retryCount: 上传自动重试次数（整体重试次数）；默认3次（即上传失败后最多重试两次）；
       * config.concurrentRequestLimit: 分片上传的并发请求量，number，默认为3；
       * config.checkByMD5: 是否开启 MD5 校验，在断点续传时校验分片，默认为 false，不开启。
       */
      const config = {
        region: qiniu.region.z0,
      };
      let putExtra = {
        fname: fileName, //文件原文件名
        params: {}, //用来放置自定义变量
        mimeType: null, //用来限制上传文件类型，为 null 时表示不对文件类型限制；限制类型放到数组里： ["image/png", "image/jpeg", "image/gif"]
      };
      const observable = qiniu.upload(file, key, token, putExtra, config);
      const observer = {
        next(res: any) {
        },
        error(err: any) {
          reject(err);
        },
        complete(res: any) {
          // const resourceInfo = {
          //   resourceUrl: process.env.VUE_APP_FILE_URL + res.key,
          //   resourceHash: res.hash,
          //   name: file.name,
          //   size: file.size,
          // };
          resolve({
            uid: file.uid,
            resourceHash: res.hash,
            name: file.name,
            size: file.size,
            resourceUrl: process.env.VUE_APP_FILE_URL + res.key,
            ...res,
          });
        },
      };
      const subscription = observable.subscribe(observer);
    });
  });
}
